import AttachmentDataProviderItem from 'owa-service/lib/contract/AttachmentDataProviderItem';
import { AttachmentFileType, AttachmentItemFile } from 'owa-attachment-file-types';

export default function createAttachmentItemFileFromDataProviderItem(
    providerItem: AttachmentDataProviderItem
): AttachmentItemFile {
    if (providerItem == null) {
        return null;
    }

    const attachmentItemFile: AttachmentItemFile = {
        attachmentItemId: providerItem.Id,
        name: providerItem.Name,
        size: providerItem.Size,
        fileType: AttachmentFileType.AttachmentItem,
        type: 'ItemIdAttachment:#Exchange',
    };

    return attachmentItemFile;
}
